import ProductImage from "../ProductImage";

import LazyProductHeroContainer from "../LazyProductHeroContainer";
import { useInView } from "react-intersection-observer";
import styles from "./index.css";

const CarouselProductHero = (props) => {
  const { ref, inView } = useInView({
    rootMargin: "200px",
    triggerOnce: true,
  });

  return (
    <LazyProductHeroContainer
      ref={ref}
      doLoad={inView}
      className={styles.productHero}
      render={(lazyProps) => <ProductImage {...{ ...lazyProps, ...props }} />}
    />
  );
};

export default CarouselProductHero;
